import Web3 from "web3";
import { CHAINS } from "../utils/chains/chains";

let fallbackChainId = localStorage.getItem("chainId") || CHAINS[0].chainId;
let index = CHAINS.findIndex((item) => item.chainId == fallbackChainId);

export const setFallbackChainId = (chainId, i) => {
  localStorage.setItem("chainId", chainId)
  fallbackChainId = chainId;
  index = i;
};

export const getIndex = () => {
  return index;
};

let web3NoAccount = null;

export const getWeb3NoAccount = () => {
  const chain = CHAINS.find((c) => c.chainId == fallbackChainId);
  if (!chain || !chain.rpc) {
    console.warn("RPC URL missing for fallback chain:", fallbackChainId);
    return new Web3(); // Will error if no provider
  }

  web3NoAccount = new Web3(new Web3.providers.HttpProvider(chain.rpc));
  return web3NoAccount;
};

export default web3NoAccount;
